export default {
  adminJobs: [],
  selectedPeriods: [],
  selectedCompanyCodes: [],
  adminJobInProgressName: null,
  adminJobsFetching: false,
  deactivateUsersJobInProgress: false,
  applicationSettingsFlags: null,
  applicationSettingsFlagsLoading: false,
  applicationSettingsFlagsUpdating: false,
  devCacheClearing: false,
  materializedViewRefreshLoading: false,
  unlockAllTaxEntriesLoading: false,
  clearBsmBalancesInProgress: false,
};
